export const FETCH_SITE_OFF_DAYS_REQUEST = '@siteOffDays/FETCH_SITE_OFF_DAYS_HISTORY_REQUEST';
export const FETCH_SITE_OFF_DAYS_SUCCESS = '@siteOffDays/FETCH_SITE_OFF_DAYS_HISTORY_SUCCESS';
export const FETCH_SITE_OFF_DAYS_FAILED = '@siteOffDays/FETCH_SITE_OFF_DAYS_HISTORY_FAILED';

export const UPSERT_SITE_OFF_DAYS_REQUEST = '@siteOffDays/UPSERT_SITE_OFF_DAYS_REQUEST';
export const UPSERT_SITE_OFF_DAYS_SUCCESS = '@siteOffDays/UPSERT_SITE_OFF_DAYS_SUCCESS';
export const UPSERT_SITE_OFF_DAYS_FAILED = '@siteOffDays/UPSERT_SITE_OFF_DAYS_FAILED';

export const RESET_SITE_OFF_DAYS_CALL_STATE = '@siteOffDays/RESET_SITE_OFF_DAYS_CALL_STATE';
